

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    couponCreateActive: false,
    discountCreateActive: false,
    activeSettingsTab: 0
};

const activeState = createSlice({
    name: "activeState",
    initialState,
    reducers: {
        setCouponCreateActive: ((state, { payload }) => {
            console.log("payload active", payload)
            state.couponCreateActive = payload
        }),
        setDiscountCreateActive: ((state, { payload }) => {
            console.log("payload active", payload)
            state.discountCreateActive = payload
        }),
        setActiveSettingsTab: ((state, { payload }) => {
            state.activeSettingsTab = payload
        })
    }
});

export const { setCouponCreateActive, setDiscountCreateActive, setActiveSettingsTab } = activeState.actions;
export default activeState.reducer;